import { SwalOptions } from 'sweetalert/typings/modules/options';
import swal from 'sweetalert';

enum NotificationType {
    success = "success",
    info = "info",
    warning = "warning",
    error = "error",
}

class Notification {
    public static success (title: string, text: string = ' '): Promise<any> {
        const opts = { title, text, icon: NotificationType.success, timer: 2000, buttons: [false] } as SwalOptions;
        return swal(opts);
    }

    public static info (title: string, text: string = ' '): Promise<any> {
        const opts = { title, text, icon: NotificationType.info, timer: 2000, buttons: [false] } as SwalOptions;
        return swal(opts);
    }

    public static warn (title: string, text: string = ' '): Promise<any> {
        const opts = { title, text, icon: NotificationType.warning, timer: 2000, buttons: [false] } as SwalOptions;
        return swal(opts);
    }

    public static error (title: string, text: string = ' '): Promise<any> {
        const opts = { title, text, icon: NotificationType.error, timer: 2000, buttons: [false] } as SwalOptions;
        return swal(opts);
    }

    public static warningDialog (title: string, text: string = ' ', cancelLabel: string, okLabel: string): Promise<any> {
        const opts = { title, text, icon: NotificationType.warning, buttons: [cancelLabel, okLabel] } as SwalOptions;
        return swal(opts);
    }
}

export default Notification;


// WEBPACK FOOTER //
// ./src/components/Notification.tsx